export default {
  allAccessory: [],
  accessory: {},
}
